/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2018 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import { getTotalPages } from "selectors/documentSelectors";

class JSStore {
  constructor() {
    this.init();
  }

  init() {
    this.nameToAnnotDataMap = new Map();
    this.isAllAnnotsDataAvailable = false;
    this.annotsDataAvailableForPageIndexes = new Set();
  }

  initStore(stores) {
    if (stores) {
      this.stores = stores;
    }
  }

  setAnnot(pageIndex, annotName, propertyObject) {
    const currentPageMap = this.nameToAnnotDataMap.has(pageIndex) ? this.nameToAnnotDataMap.get(pageIndex) : null;
    if (currentPageMap && currentPageMap.has(annotName)) {
      const annotMap = currentPageMap.get(annotName);
      if (propertyObject.hasOwnProperty("hidden")) {
        annotMap.isHidden = propertyObject.hidden;
      } else if (propertyObject.hasOwnProperty("name")) {
        if (currentPageMap.has(propertyObject.name)) return; // Already contains annot with given name
        annotMap.name = propertyObject.name;
        currentPageMap.set(propertyObject.name, currentPageMap.get(annotName));
        currentPageMap.delete(annotName);
      }
    }
  }

  addAnnotToNameMap(pageIndex, annotData) {
    const annotName = annotData.name;
    if (!this.nameToAnnotDataMap.has(pageIndex)) {
      this.nameToAnnotDataMap.set(pageIndex, new Map());
    }
    const currentPageMap = this.nameToAnnotDataMap.get(pageIndex);
    if (annotName && !currentPageMap.has(annotName)) currentPageMap.set(annotName, annotData);
  }

  setIsAllAnnotsDataAvailable(status) {
    this.isAllAnnotsDataAvailable = status;
  }

  setIsAnnotsDataAvailableForPageIndex(pageIndex) {
    this.annotsDataAvailableForPageIndexes.add(pageIndex);
    if (this.annotsDataAvailableForPageIndexes.size === getTotalPages(this.stores)) {
      this.isAllAnnotsDataAvailable = true;
    }
  }

  resetAnnotsData() {
    this.isAllAnnotsDataAvailable = false;
    this.nameToAnnotDataMap = new Map();
    this.annotsDataAvailableForPageIndexes = new Set();
  }
}

export { JSStore };
